export const PROJECT_NAME = 'access_objects'
